export enum StockVersionTypes {
  FULL = 'full',
  NONE = 'none',
  LIGHT = 'light',
}
